import initializePickers, { EnumPickerType } from '../plugins/PluginPicker'
import Swiper from 'swiper'
import { EffectFade, Navigation, Thumbs } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs';

window.addEventListener('load', () => {
  // let swiperMainInstance: any
  // let swiperThumbsInstance: any

  function initSwiper(slidersWrapper: NodeListOf<Element>) {
    if (slidersWrapper.length > 0) {
      slidersWrapper.forEach((wrapper) => {

        const sliderThumbs = wrapper.querySelector('[data-slider="product-colors-thumbs"]') as any
        const sliderMain = wrapper.querySelector('[data-slider="product-colors"]') as any
        const sliderMainOld = wrapper.querySelector('[data-slider="product-colors-old"]') as any

        if (sliderMain?.swiper) {
          sliderMain.swiper.destroy(true, true)
        }
        if (sliderThumbs?.swiper) {
          sliderThumbs.swiper.destroy(true, true)
        }

        let swiperThumbsInstance: any = null

        if (sliderThumbs) {
          swiperThumbsInstance = new Swiper(sliderThumbs, {
            slidesPerView: 2,
            spaceBetween: 5,
            direction: "horizontal",
            speed: 300,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            breakpoints: {
              1600: {
                spaceBetween: 15,
                direction: "vertical",
                slidesPerView: 5,
              },
              1200: {
                spaceBetween: 10,
                direction: "vertical",
                slidesPerView: 5,
              },
              992: {
                spaceBetween: 10,
                direction: "horizontal",
                slidesPerView: 5,
              },
              768: {
                spaceBetween: 10,
                direction: "horizontal",
                slidesPerView: 4,
              },
              360: {
                spaceBetween: 10,
                direction: "horizontal",
                slidesPerView: 3,
              },
            },
          })
        }

        if (sliderMain) {
          new Swiper(sliderMain, {
            modules: [Navigation, EffectFade, Thumbs],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 300,
            effect: 'fade',
            navigation: {
              nextEl: wrapper.querySelector('[data-controls="next"]'),
              prevEl: wrapper.querySelector('[data-controls="prev"]'),
            },
            thumbs: {
              swiper: swiperThumbsInstance,
            },
          })
        }

        if (sliderMainOld) {
          new Swiper(sliderMainOld, {
            modules: [Navigation, EffectFade],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            // loop: true,
            allowTouchMove: false,
            speed: 300,
            effect: 'fade',
            // observer: true,
            // observeParents: true,
            // observeSlideChildren: true,
            navigation: {
              nextEl: '[data-controls="next"]',
              prevEl: '[data-controls="prev"]',
            },
          })
        }
      })
    }
  }

  // EXAMPLES:
  initializePickers({
    picker: {
      type: EnumPickerType.SINGLE,
      selector: '[data-picker-colors]',
    },
    buttonSelector: '[data-picker-btn-colors]',
    itemSelector: (window.innerWidth <= 767) ? '[data-picker-item-colors-mobile]' : '[data-picker-item-colors]',
    activeIndexes: [0],
    noSelected: false,
    activeClass: 'active',
    onInit: (state) => {

      const wrapper = state.element.querySelectorAll('[data-slider-wrapper]')

      initSwiper(wrapper)
    },
    onStateChange: (state) => {
      const wrapper = state.element.querySelectorAll('[data-slider-wrapper]')
      initSwiper(wrapper)
    },
  })
})
